<template>
   <HeroRowSection v-if="layout === 'row'" v-bind="childProps" />
   <HeroColSection v-else-if="layout === 'column'" v-bind="childProps" />
</template>

<script setup lang="ts">
import type { CTAItemData } from "@/components/ui/buttons/PageCTAItems.vue";
import type { ContainerTheme, ImageData } from "@/types";

// props
// -----------------------------------------
const props = withDefaults(
   defineProps<{
      type: "hero_section";
      heading: string;
      image: ImageData;
      layout: "column" | "row";
      kicker?: string;
      description?: string;
      margin?: string;
      ctas?: CTAItemData[];
      theme?: ContainerTheme;
   }>(),
   {}
);

// computed
// -----------------------------------------
// remove unused props
const childProps = computed(() => {
   if (!props) return null;

   const childProps = {
      heading: props.heading,
      image: props.image,
      kicker: props.kicker,
      description: props.description,
      ctas: props.ctas,
      theme: props.theme,
   };

   return childProps;
});
</script>

<style lang="scss" scoped></style>
